// ─── Logo ─────────────────────────────────────────────────────────────────
//
// Shared component for rendering the Receipt Chaser logo. Two variants:
//
//   variant="icon"  : just the R-mark, no text. Used in compact slots
//                     like the navbar and small badges.
//   variant="full"  : the icon + RECEIPT CHASER wordmark below. Used on
//                     auth pages, hero blocks, and other places where the
//                     brand needs to lead.
//
// The image files live in /public/brand/ and are served as static assets.
// Pass `size` to control the height in pixels; the image scales to keep
// aspect ratio.

export default function Logo({ variant = 'icon', size = 32, alt = 'Receipt Chaser', style = {} }) {
  const src = variant === 'full'
    ? '/brand/full-transparent.png'
    : '/brand/icon-transparent.png'

  return (
    <img
      src={src}
      alt={alt}
      height={size}
      style={{
        display: 'block',
        width: 'auto',
        height: size,
        ...style,
      }}
    />
  )
}
